import { useEffect, useState } from "react";

const usePaginator = (itemsPerPage: number, items: any[]) => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [itemsToShow, setItems] = useState<any[]>([]);

  useEffect(() => {
    onPageChange(1);
  }, [items, itemsPerPage]);

  const onPageChange = (page: number) => {
    setCurrentPage(page);
    const start = (page - 1) * itemsPerPage;
    const end = start + itemsPerPage;
    const res = items.slice(start, end);
    setItems(res);
    setTotalPages(Math.ceil(items.length / itemsPerPage));
  };

  return {
    onPageChange,
    currentPage,
    totalPages,
    itemsToShow,
  };
};

export default usePaginator;
